// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ElecCharts_wrapper__27qjC"};